import { useState } from 'react'
import { useNavigate } from 'react-router'

import { signup } from '../store/actions/user.actions'

import { ImgUploader } from '../cmps/ImgUploader'
import { userService } from '../services/user'
import { Button } from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'

export function Signup() {
  const [credentials, setCredentials] = useState(userService.getEmptyUser())
  const navigate = useNavigate()

  function clearState() {
    setCredentials({ username: '', password: '', fullname: '', imgUrl: '' })
  }

  function handleChange(ev) {
    const type = ev.target.type

    const field = ev.target.name
    const value = ev.target.value
    setCredentials({ ...credentials, [field]: value })
  }

  async function onSignup(ev = null) {
    if (ev) ev.preventDefault()

    if (!credentials.username || !credentials.password || !credentials.fullname)
      return
    await signup(credentials)
    clearState()
    navigate('/')
  }

  function onUploaded(imgUrl) {
    setCredentials({ ...credentials, imgUrl })
  }

  return (
    <form className="signup-form" onSubmit={onSignup}>
      <h1 className="signup-title">SignUp to StayFlex !</h1>
      <input
        type="text"
        className="input text-input"
        name="fullname"
        value={credentials.fullname}
        placeholder="Fullname"
        onChange={handleChange}
        required
      />
      <input
        type="text"
        className="input text-input"
        name="username"
        value={credentials.username}
        placeholder="Username"
        onChange={handleChange}
        required
      />
      <input
        type="password"
        className="input password-input"
        name="password"
        value={credentials.password}
        placeholder="Password"
        onChange={handleChange}
        required
      />

      <label className="upload-btn">
        <div className="upload-flex">

        <CloudUploadIcon />
        <ImgUploader onUploaded={onUploaded} />
        </div>
      </label>

      <button className="signup-btn">SignUp</button>
    </form>
  )
}
